import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'app-lms-calendar',
  templateUrl: './lms-calendar.component.html',
  styleUrls: ['./lms-calendar.component.scss'],
})
export class LmsCalenderComponent implements OnInit, OnChanges {
 @Input() selected: any;
  @Input() clearAll: any;
  @Input() drops = 'down';
  @Input() minDate:any;
  @Input() maxDate:any;
  @Input() restrictFutureDates=false;
  @Output() changedDates = new EventEmitter();
  
  maxdate:any=null;
  constructor() {}

  ngOnInit(): void {
    if(this.restrictFutureDates){
      this.selected={
        start:moment().subtract(1,'months').startOf('month'),
        end:moment().endOf('month')
      };
    }
  }

  rangeClicked(event): void {}

  datesUpdated(date): void {
    this.changedDates.emit(this.selected);
  }

  ngOnChanges(): void {
    if (this.clearAll) {
      this.selected = '';
    }
  }
  ngOndestroy():void{
    this.selected=null;
  }
}
